// extracted by mini-css-extract-plugin
export var divider = "_s9-0";
export var systemMessage = "_s9-1";
export var systemMessageWrapper = "_s9-2";